import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    class: String
  };

  connect() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.element.classList.add(this.classValue || "scale-in");
          this.observer.unobserve(this.element);
        }
      });
    }, {
      threshold: 1.0
    });

    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }
}
